import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@this/src/components/shared/ui/data_displays/table';
import type AnaReservation from '@this/src/domain/arrangement/ana_reservation_total';
import type { ReservationType } from '../../share/reservation_type';
import AirAutoAnaReservationTotalTableRow from './total_result_table_row';

interface Props {
  anaReservationTotals: AnaReservation[];
  fetchTodos: () => void;
  reservationType: ReservationType;
}

const AirAutoAnaReservationTotal: React.FC<Props> = ({ anaReservationTotals, fetchTodos, reservationType }) => {
  return (
    <Table stickyHeader>
      <TableHead>
        <TableRow>
          <TableCell>予約日</TableCell>
          <TableCell>予約対象アイテム件数</TableCell>
          <TableCell>予約完了件数</TableCell>
          <TableCell>予約完了合計金額</TableCell>
          <TableCell>総数確認日</TableCell>
          <TableCell>総数確認者</TableCell>
          <TableCell>確認</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {anaReservationTotals.map(anaReservationTotal => (
          <AirAutoAnaReservationTotalTableRow
            key={anaReservationTotal.reservationDate.format('YYYY-MM-DD')}
            anaReservationTotal={anaReservationTotal}
            onApprove={() => fetchTodos()}
            reservationType={reservationType}
          />
        ))}
      </TableBody>
    </Table>
  );
};

export default AirAutoAnaReservationTotal;
